import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
declare var $: any;
import { ApiService } from '../../../_services/api.service';
import { first } from 'rxjs/operators';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-cnamgs-reportview',
  templateUrl: './cnamgs-reportview.component.html',
  styleUrls: ['./cnamgs-reportview.component.scss']
})
export class CnamgsReportviewComponent implements OnInit {

  id: any;
  page: any;
  public todayDate: any = new Date();
  response: any;
  cnamgsReport: any;
  purpose: any;
  employerDetails: any;
  reportAllList: any;
  amount: any;
  redirectUrl: any;
  ref_id: any;
  penaltyRate: any;
  paymentPenaltyRate: any;
  penaltyParent: any;
  showAllDtsList: boolean = false;
  showAllPaymentList: boolean = false;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private snackBar: MatSnackBar) {
    if (this.router.getCurrentNavigation().extras.state) {
      this.page = this.router.getCurrentNavigation().extras.state.data;
      console.log("19", this.page)
    }
    this.ref_id = this.route.snapshot.queryParamMap.get('reference_id');
  }

  ngOnInit() {
    console.log("20", this.page)
    this.route.params.subscribe(
      (params: Params) => {
        console.log("36", params['id']);
        console.log("37", params);
        if (params['id'] != 'cnamgs') {
          this.id = params['id'];
          // this.purpose = params['purpose'];
          this.getReportsbyID()

        } else {
          this.page = params['id'];
          console.log("114", this.page)
        }
      });
    // if (this.route.snapshot.paramMap.get('purpose')) {
    //   this.purpose = this.route.snapshot.paramMap.get('purpose');
    //   console.log("139", this.purpose)
    // }
  }

  editReport() {
    this.router.navigate(['cnamgs-report', this.employerDetails.uuid]);
  }

  getReportsbyID() {
    this.ngxUiLoaderService.start();
    console.log("150", this.id)
    this.api.getCnamgsReportsbyID(this.id).pipe(first())
      .subscribe(data => {
          this.response = data;
          this.ngxUiLoaderService.stop();
          if (this.response.status == 200) {
            this.employerDetails = this.response.results.data;
            console.log("157", this.employerDetails)
            console.log("158", this.employerDetails.status)
            this.cnamgsReport = this.response.results.quarter;
            this.reportAllList = this.response.results
            this.amount = this.reportAllList.paid_to_cnamgs
            this.penaltyRate = this.reportAllList.penalities.penalitiesMonthArray;
            this.paymentPenaltyRate = this.reportAllList.penalities.penalityPaymentArray;
            this.penaltyParent = this.response.results.penalities;
            console.log(this.penaltyParent)
            console.log(this.penaltyRate)
            if (this.employerDetails.status == 4) {
              this.router.navigate(['cnamgs-report', this.id]);
            }
            console.log("152", this.cnamgsReport)
            console.log("153", this.amount)
            console.log("154", this.employerDetails.employer_cnamgs)
            if (this.ref_id) {
              this.executePayment()
            }
          } else {
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  executePayment() {
    var data = {};
    data['uuid'] = this.id;
    data['entity_type'] = '4';
    data['ref_id'] = this.ref_id;
    this.ngxUiLoaderService.start();
    this.api.paymetExecute(data).pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            //  this.processResponse(this.response);
            this.router.navigate(['/cnamgs-reportlist'], { state: { payment_success: 1 } });
          } else {
            this.snackBar.open(this.response.message, "Ignorer", {
              duration: 5000,
            });
          }
        },
        error => {});
  }

  paymentSubmit() {
    this.router.navigate(['/payment/cnamgs'], { state: { report_id: this.id, amount: this.amount } });
  }
  showcnamgsList() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    $('#reportModal').modal('hide');
    this.id = 'normalcnamgs';
    // switch (this.id) {
    //   case 'normalcnamgs':
    //     {
    //       console.log('aa')
    //       $('.cnamgs_report').addClass('dNone');
    //       $('.payment_table').addClass('dNone');
    //       $('.dateTerminateInput').removeClass('dNone');
    //       $('.dateTerminate').removeClass('dBlock');

    //       $('.pendingStatus').removeClass('dBlock');
    //       $('.ongoingStatus').removeClass('dNone');
    //       $('.payNowStatus').addClass('dNone');
    //       $('.rejectedStatus').addClass('dNone');
    //       $('.completedStatus').addClass('dNone');

    //       $('input').removeClass('changeInput_style');
    //       $('.tableFooter').removeClass('dNone');
    //       $('#resubMit_btn').removeClass('d-block');
    //       $('#submit_btn').addClass('d-block');
    //       break;
    //     }
    // }

  }
  goToViewPage() {
    $('#successModal').modal('hide');

    this.router.navigate(['/cnamgs-reportlist'], { state: { data: this.page } });
  }

  goback() {
    this.router.navigate(['/cnamgs-reportlist'], { state: { data: this.page } });
  }

  paymentInitiate() {
    var data = {};
    data['uuid'] = this.id;
    data['entity_type'] = '4';
    data['total_amount'] = this.amount;
    data['return_url'] = window.location.href.split('?')[0];
    this.ngxUiLoaderService.start();
    this.api.paymentInitiate(data).pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            this.redirectUrl = this.response.url;
            this.router.ngOnDestroy();
            window.location.href = this.redirectUrl;
          } else {
            this.snackBar.open(this.response.message, "Ignorer", {
              duration: 2000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  ViewAllLateDtsList() {
    console.log("193")
    this.showAllDtsList = !this.showAllDtsList;
  }
  ViewAllLatepaymentList() {
    console.log("197")
    this.showAllPaymentList = !this.showAllPaymentList;
  }
}
